<template>
  <div class="model-selector-card">
    <pdl-card :qaid="`model-option-card-${idFromModelName}`">
      <template #bodyContent>
        <input
          :id="`option-${idFromModelName}`"
          ref="modelInput"
          v-model="localValue"
          type="radio"
          name="model-option"
          :value="model.code"
          :checked="isSelected"
          class="absolute block top-0 left-0 right-0 bottom-0 w-full h-full pointer-events-auto cursor-pointer z-10 rounded-lg"
          @change="emitUpdate"
        />
        <div class="relative z-20">
          <div class="flex justify-between items-center">
            <label
              :for="`option-${idFromModelName}`"
              class="text-sm font-bold grow"
              :qaid="`model-option-name-${idFromModelName}`"
            >
              {{ model.name }}
            </label>
            <div class="text-sm flex-none" :qaid="`model-option-price-${idFromModelName}`">
              <product-price
                v-if="model.code"
                :variant-code="model.code"
                :is-archived="model.isArchived"
                :is-showing-comp-value="false"
                :is-model-selector-card="true"
              />
            </div>
          </div>
        </div>
      </template>
    </pdl-card>
  </div>
</template>

<script>
import {PdlCard} from '@pedal/pdl-card';
import {mapState} from 'vuex';
import {toKebabCase} from '@/utils/util';
import ProductPrice from '@/components/containers/buy-zone/ProductPrice';
import {loadModelPricing} from '@/components/containers/pdp/utils/product-pricing.js';

export default {
  components: {
    PdlCard,
    ProductPrice,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState('familyDetails', ['selectedModelId']),

    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    idFromModelName() {
      return toKebabCase(this.model.name);
    },
    isSelected() {
      return this.selectedModelId === this.model.code;
    },
  },
  created() {
    loadModelPricing(this.model);
  },
  methods: {
    emitUpdate() {
      this.$emit('update:modelValue', this.model.code);
    },
  },
};
</script>

<style lang="scss" scoped>
.model-selector-card {
  scale: 1;

  &:has(input[type='radio']:active) {
    scale: 0.99;
  }
}

:deep(.pdl-card__body) {
  padding: 0.625rem;
  pointer-events: none;
  background-color: var(--white);
}

input[type='radio'] {
  appearance: none;
  color: var(--gray-20);
  line-height: 0;
  transition: box-shadow 0.2s, background-color 0.2s, color 0.2s, transform 0.1s;
  border: 1px solid currentColor;
  background-color: var(--white);
  box-shadow: inset 0 0 0 #007ab800;

  &:checked {
    color: var(--blue-100, #007ab8);
    background-color: var(--blue-10, #e6f2f8);
  }

  @media (hover: hover) {
    &:hover {
      color: var(--blue-100, #007ab8);
      box-shadow: inset 0 0 2px 1px var(--blue-100, #007ab8);
      background-color: var(--blue-10, #e6f2f8);
    }
  }

  &:focus-visible {
    outline: 2px solid var(--blue-100);
    background-color: var(--blue-10, #e6f2f8);
    outline-offset: 0.125rem;
  }
}
</style>
